import axiosInstance from '../Lib/axios';
import {
  GET_COMMERICAL_USER_SUCCESSFULLY,
  GET_COMMERICAL_USER_FAILED,
  GET_RESIDENTIAL_PROPOSALS_SUCCESSFULLY,
  GET_RESIDENTIAL_PROPOSALS_FAILED,
  UPDATE_USER_DETAILS,
  UPDATE_USER_DETAILS_FAILED,
  GET_COMMUNITY_INFO_DETAILS_SUCCESSFULLY,
  GET_COMMUNITY_INFO_FAILED,
  UPDATE_COMMUNITY_INFO_DETAILS_SUCCESSFULLY,
  UPDATE_COMMUNITY_INFO_FAILED,
  GET_PAYMENT_DETAILS_SUCCESSFULLY,
  GET_PAYMENT_DETAILS_FAILED,
} from './types';

//Get Account Info
export const getCommericalAccountInfo = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/commerical-customer/${params}/`, {})
      .then((response) => {
        dispatch({
          type: GET_COMMERICAL_USER_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_COMMERICAL_USER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update Account Info
export const updateCommericalAccountInfo = (params, uuid) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/crm/commerical-customer/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_USER_DETAILS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_USER_DETAILS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get all Proposals
export const getProposalsListing = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/commerical-crm/`, { params })
      .then((response) => {
        dispatch({
          type: GET_RESIDENTIAL_PROPOSALS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_RESIDENTIAL_PROPOSALS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// View Proposal PDF
export const getProposalPdf = (uuid) => {

  return () => {
    return axiosInstance
      .get(`/crm/commerical-crm/${uuid}/proposal-pdf/`, {})
      .then((response) => {

        var byteCharacters = atob(response.data.data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }

        }
      });
  };
};


//Get Community Info
export const getCommunityInfo = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/commercial-community/`, { params })
      .then((response) => {
        dispatch({
          type: GET_COMMUNITY_INFO_DETAILS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_COMMUNITY_INFO_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Community Info
export const updateCommunityInfo = (params) => {
  return (dispatch) => {
    return axiosInstance
      .put(`/crm/commercial-community/${params.uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_COMMUNITY_INFO_DETAILS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_COMMUNITY_INFO_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Payment
export const getPayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/last-three-payments`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAYMENT_DETAILS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAYMENT_DETAILS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};